module.exports = __webpack_public_path__ + "media/images/athletes/3581-9cb2a869274c13b30a46acb4e4e921bb.png";